import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b73f40e0&class=full-heigth"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=b73f40e0&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitHub\\ita.GroupTravel.Website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b73f40e0')) {
      api.createRecord('b73f40e0', component.options)
    } else {
      api.reload('b73f40e0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b73f40e0&class=full-heigth", function () {
      api.rerender('b73f40e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/travel/index.vue"
export default component.exports